module.exports = __webpack_public_path__ + "static/media/photo19.ae49e149.jpg";